module.exports = __webpack_public_path__ + "img/countbg3.7e76d4ec.png";